import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { userLoginRequest } from '../../actions/LoginActions';
import validateInput from '../../shared/validators/LoginValidator';
import logo from '../../static/img/logo.webp';

const styles = theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  message: {
    textAlign: 'center',
  },
  formControl: {
    margin: theme.spacing(),
  },
  button: {
    marginTop: theme.spacing(5),
  },
  logo: {
    height: 60,
    marginBottom: theme.spacing(3),
  },
  form: {
    width: '100%',
  },
  forgotPasswordButton: {
    fontSize: 12,
    float: 'left',
  },
  noAccountButton: {
    fontSize: 12,
  },
  helperLinks: {
    fontSize: '.8em',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(4),
    textAlign: 'center',
  },
});

function Message(props) {
  const {
    status,
    className,
    error,
  } = props;
  // if error, display it
  let errorMessage = 'Login failed.. please try again';
  if (error) {
    if (error.status === 401) {
      errorMessage = 'Invalid credentials, please try again';
    }
  }
  if (status === 'error') {
    return (
      <Typography
        className={className}
        variant="subtitle1"
      >
        {errorMessage}
      </Typography>
    );
  }
  return null;
}

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      errors: {},
      isLoading: false,
      showPassword: false,
    };

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordToggle = this.handlePasswordToggle.bind(this);
    this.handlePasswordMouseDown = this.handlePasswordMouseDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.loadingSpinnerDisplay = this.loadingSpinnerDisplay.bind(this);
  }

  handleUsernameChange(e) {
    e.preventDefault();
    this.setState({ username: e.target.value });
  }

  handlePasswordChange(e) {
    e.preventDefault();
    this.setState({ password: e.target.value });
  }

  isValid() {
    const {
      errors,
      isValid,
    } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  handlePasswordToggle() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  handlePasswordMouseDown(e) {
    e.preventDefault();
  }

  handleSubmit(e) {
    const { username, password } = this.state;
    e.preventDefault();
    if (this.isValid()) {
      const { dispatch } = this.props;
      dispatch(userLoginRequest(username, password));
    } else {
      // FIXME
      // do stuff
      // this.setState({errors: {formError: 'Login Error'}});
    }
  }

  buttonState() {
    const { username, password } = this.state;
    let disabled = true;
    if (username && password !== '') {
      disabled = false;
    }
    return disabled;
  }

  loadingSpinnerDisplay() {
    const { status, classes } = this.props;
    if (status === 'requested') {
      return (
        <LinearProgress color="secondary" className={classes.progress} />
      );
    }
    return null;
  }

  render() {
    const {
      showPassword,
      password,
      username,
      errors,
    } = this.state;
    const {
      status,
      token,
      classes,
      error,
      to,
    } = this.props;
    // redirect when form submit is successful
    if (status === 'success' && token !== undefined) {
      return (
        <Redirect to={to || '/account/home'} />
      );
    }
    return (
      <Paper>
        <div className={classes.paper}>

          <img src={logo} alt="Nia" className={classes.logo} />

          <Message
            className={classes.message}
            status={status}
            error={error}
          />

          <form className={classes.form} onSubmit={this.handleSubmit}>
            {/* USERNAME */}
            <FormGroup row>
              <FormControl
                fullWidth
                className={classes.formControl}
              >
                <InputLabel>Username or Email</InputLabel>
                <Input
                  value={username}
                  onChange={this.handleUsernameChange}
                />
                <FormHelperText id="username-error-text">
                  {errors.username}
                </FormHelperText>
              </FormControl>
            </FormGroup>

            {/* PASSWORD */}
            <FormGroup row>
              <FormControl fullWidth className={classNames(classes.margin, classes.formControl)}>
                <InputLabel htmlFor="adornment-password">Password</InputLabel>
                <Input
                  id="adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={this.handlePasswordChange}
                  endAdornment={(
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.handlePasswordToggle}
                        onMouseDown={this.handlePasswordMouseDown}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )}
                />
              </FormControl>
            </FormGroup>

            {/* Nav Links */}
            <Button className={classes.forgotPasswordButton} href="/account_recovery">Forgot password?</Button>


            {/* SUBMIT BUTTON */}
            <Button
              fullWidth
              disabled={this.buttonState()}
              type="submit"
              variant="contained"
              className={classes.button}
              color="secondary"
            >
              Login
            </Button>

            {/* Helpers Links */}
            <div className={classes.helperLinks}>
              <Typography>Need an account? <Button className={classes.noAccountButton} href="/register">Sign Up</Button></Typography>
              <Typography>Looking for Nia® On Demand? <Button className={classes.noAccountButton} href="https://niaondemand.com">Click Here</Button></Typography>
              <Typography>Need support? <Button className={classes.noAccountButton} href="/contact">Contact Us</Button></Typography>
            </div>
          </form>
        </div>
        {this.loadingSpinnerDisplay()}
      </Paper>
    );
  }
}

LoginForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  status: PropTypes.string,
  classes: PropTypes.object.isRequired,
  token: PropTypes.string,
  error: PropTypes.object,
  userFirstName: PropTypes.string,
  to: PropTypes.string,
};

Message.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
  userFirstName: PropTypes.string,
  error: PropTypes.object,
};

function mapStateToProps(state) {
  const { status, error } = state.loginReducer;
  const { token } = state.loginReducer;
  return {
    status,
    token,
    error,
  };
}

export default withStyles(styles)(connect(mapStateToProps)(LoginForm));
